<template>
    <div class="view view--add-tile">
        <div class="view--add-tile__step-1" v-if="!category">
            <router-link class="btn is-large is-primary view--add-tile__step-1__btn"
                         v-bind:to="{ name: 'tiles.add', params: { category: 'custom', startdesk: activeStartdesk } }">
                <span class="jam jam-plus"></span>{{ __('Add custom tile') }}
            </router-link>

            <span class="view__separator"><span>{{ __('or choose category') }}</span></span>

            <category-list category-type="tiles"
                           v-bind:list-link="{ name: 'tiles.add' }" />
        </div>

        <edit-tile v-bind:category="category"
                   v-bind:startdesk="activeStartdesk.id"
                   v-if="category && (category == 'custom' || category == 'admin') && activeStartdesk"
        />

        <tile-list list-type="add"
                v-bind:category="parseInt(category)"
                v-bind:selectable="true"
                v-bind:show-actions="false"
                v-bind:show-add-button="false"
                v-bind:show-back-button="true"
                v-bind:show-filters="{ 'category': true }"
                v-bind:show-title="false"
                v-bind:show-thumbnail-slider="false"
                v-if="category && category != 'custom' && category != 'admin'"
        />
    </div>
</template>

<script>
    import categoryList from '../../components/CategoryList.vue';
    import editTile from '../../components/EditTile.vue';
    import tileList from '../../components/TileList.vue';

    export default {
        beforeRouteUpdate: function (to, from, next) {
            this.category = to.params.category || null;

            next();
        },
        components: {
            categoryList,
            editTile,
            tileList
        },
        data: function () {
            return {
                category: this.$route.params.category || null
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/tiles/Add.vue